









import { Vue, Component, Prop } from 'vue-property-decorator';
import Container from '@/components/Registration/v2/Container.vue';
import RegistrationCard from '@/components/Registration/v2/Card.vue';
import CardHeader from '@/components/Registration/v2/Header.vue';
import AccountLockedForm from './AccountLockedForm.vue';
import axios from 'axios';
import { vxm } from '@/store.vuex';

@Component({
  name: 'AccountLocked',
  components: {
    Container,
    RegistrationCard,
    CardHeader,
    AccountLockedForm,
  },
})
export default class AccountLocked extends Vue {
  $wlToastr: any;

  get getTitle() {
    return this.$t('account-locked.title');
  }

  get getEmailParam() {
    return (
      vxm.users.UserParams.email ||
      (this.$route.params.username || this.$cookies.get('userName'))
    );
  }

  async sendOtp() {
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/v2/forgotPassword',
      {
        companyCode: vxm.jobs.BrandingInfo.companycode,
        userEmail: this.getEmailParam,
      },
      {
        headers: {
          //Authorization: 'Bearer ' + vxm.users.getToken,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    if (resp.data.success) {
      this.$wlToastr(
        'success',
        this.$t('account-locked.toast.codesentmessage'),
        '',
      );
      vxm.users.setRouterAfterOTPForm('ChangePasswordV2');
      vxm.users.setForceChangePwd(true);
      this.$router.push({ name: 'OTPLogin' });
    } else {
      if (
        resp.data.errorMessage ===
        this.$t('forgotpassword.socialmedia.errormessage')
      ) {
        //this.showSumbitButton = false;
      }
      //this.errors.userEmail = resp.data.errorMessage;
    }
  }

  mounted() {
    //this.username = this.$cookies.get('userName');
  }
}
